module.exports = __webpack_public_path__ + "img/item4.90795440.png";